import { AfterViewInit, Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import * as Chart from 'chart.js';
import 'chartjs-plugin-datalabels';
import * as _ from 'lodash';
import * as numeral from 'numeral';
import { ModalController } from '@ionic/angular';
import { ModalDetalheGraficoComponent } from '../../modal-components/modal-detalhe-grafico/modal-detalhe-grafico-component';

@Component({
    selector: 'chart-line-component',
    templateUrl: 'chart-line-component.html',
    styleUrls: ['./chart-line-component.scss']
})

export class ChartLineComponent implements OnInit, AfterViewInit {

    @ViewChild('lineChart', { static: false }) lineChart;

    @Input() titulo: string;
    @Input() lista: any = [];

    @Input() isFilter: boolean;
    @Input() isDetail: boolean;
    @Input() isLegend: boolean;
    @Input() legRotate: any;
    @Input() legBottom: any;
    @Input() backgroundColor: boolean;
    @Input() infoData: any = {};
    @Input() stepSize: any;
    @Input() filter: any;

    @Output() filtroState = new EventEmitter();

    chart: any;
    regiaSelecionada: any;
    legends: any[] = [];

    constructor(private modalCtrl: ModalController) {
        console.log('filter----', this.filter);
    }

    ngOnInit() {
        console.log('ngAfterViewInit -> ChartPieComponent');

        if (this.filter) {
            this.regiaSelecionada = this.filter;
        }
    }

    ngAfterViewInit() {
        this.createLineChart();
    }

    filtrarRegiao(regiao) {
        this.regiaSelecionada = regiao;
        this.filtroState.emit(regiao);
    }

    async openDetalhe() {
        const modal = await this.modalCtrl.create({
            component: ModalDetalheGraficoComponent,
            keyboardClose: true,
            backdropDismiss: false,
            cssClass: 'modal-detalhe-grafico',
            componentProps: {
                chart: this.chart,
                isFilter: this.isFilter,
                legRotate: this.legRotate,
                isLegend: this.isLegend,
                legBottom: this.legBottom,
                titulo: this.titulo,
                legends: this.legends,
            }
        }
        );

        // modal.onDidDismiss().then((evt: any) => {
        // });
        return await modal.present();
    }

    createLineChart() {
        const chart = this.lineChart.nativeElement.getContext('2d');
        const gradient = chart.createLinearGradient(0, 0, 0, 450);

        if (this.titulo.split(' ')[0] === 'Óbitos') {
            gradient.addColorStop(0, 'rgba(154, 54, 187, 0.3)');
            gradient.addColorStop(0.5, 'rgba(154, 54, 187, 0.05)');
        } else {
            gradient.addColorStop(0, 'rgba(29, 165, 132, 0.3)');
            gradient.addColorStop(0.5, 'rgba(29, 165, 132, 0.05)');
            // gradient.addColorStop(1, 'white');
        }

        const option = {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: false,
            },
            legend: {
                display: true,
            },
            tooltips: {
                enabled: true,
                backgroundColor: '#000',
                titleFontSize: 14,
                titleFontColor: '#FFFFFF',
                bodyFontColor: '#FFFFFF',
                bodyFontSize: 13,
            },
            scales: {
                xAxes: [{
                    ticks: {
                        fontColor: '#8498AE',
                        fontFamily: 'Circular Std',
                    },
                    gridLines: {
                        display: true,
                        color: '#ffffff',
                    }
                }],
                yAxes: [{
                    // type: 'linear',
                    ticks: {
                        fontColor: '#8498AE',
                        fontFamily: 'Circular Std',
                        beginAtZero: true,
                        stepSize: this.stepSize,
                        callback(value) {
                            const n = value.toString();
                            let r = '';
                            let x = 0;

                            for (let i = n.length; i > 0; i--) {
                                r += n.substr(i - 1, 1) + (x === 2 && i !== 1 ? '.' : '');
                                x = x === 2 ? 0 : x + 1;
                            }

                            return r.split('').reverse().join('');

                            // if (value >= 1000000) {
                            //     value = (value / 1000000) + 'M';
                            // } else if (value >= 1000) {
                            //     value = (value / 1000) + 'K';
                            // }
                            // return value;
                        }
                    },
                    gridLines: {
                        display: true,
                        color: '#E5F3FF',
                    }
                }]
            }
        };

        if (this.isLegend) {
            for (let i = 0; i < this.infoData.datasets.length; i++) {
                this.legends.push({ label: this.infoData.datasets[i].label, bgColor: this.infoData.datasets[i].borderColor });
            }
        }

        if (this.backgroundColor) {
            for (let i = 0; i < this.infoData.datasets.length; i++) {
                this.infoData.datasets[i].backgroundColor = gradient;
            }
        }

        this.chart = new Chart(chart, {
            type: 'line',
            data: this.infoData,
            options: option
        });
    }
}
